export const PROMOTIONS_PRICE_STATE = {
    gte: 0,
    lte: 10000
};
